import styled, { css } from "styled-components";
import { CardType } from "./index";
import { px2rem } from "../../../../../utils/css";
const getMainBorder = (type) => {
    return type === CardType.Normal
        ? `${px2rem(6)} ${px2rem(6)} 0 0`
        : `${px2rem(6)} 0 0 ${px2rem(6)}`;
};
const getRtBorder = (type) => {
    return type === CardType.Normal ? `0 ${px2rem(6)} 0 ${px2rem(2)}` : `0 0 0 ${px2rem(2)}`;
};
export const BannerWrapper = styled.div `
	position: relative;
	font-size: 0px;
	z-index: 10;
	${(props) => {
    const { uiType } = props;
    return css `
			border-radius: ${getMainBorder(uiType)};
			.ltImg {
				position: absolute;
				top: 0;
				left: 0;
				border-radius: ${px2rem(6)} 0 ${px2rem(2)} 0;
				height: ${px2rem(16)};
			}
			.rtImg {
				position: absolute;
				top: 0;
				right: 0;
				border-radius: ${getRtBorder(uiType)};
				height: ${px2rem(16)};
			}
			.countdown {
				position: absolute;
				bottom: 0;
				width: 100%;
			}
			.mainImg {
				width: 100%;
				height: 100%;
				border-radius: ${getMainBorder(uiType)};
			}
		`;
}}
`;
